import { CircularProgress, CssBaseline, Grid, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import { ROUTE_PATHS } from "./Routes/constants";
import { initMixpanel } from "./Utils/mixpanel";
import useAuthState from "./Utils/store";
require("moment/locale/tr");

function AppContent() {
  const location = useLocation();
  initMixpanel();
  return (
    // wrap="nowrap": with the default wrap, the column flex algorithm hands
    // spare viewport height to the footer item too, painting a white band
    // below the footer on tall screens.
    <Grid container direction="column" wrap="nowrap" style={{ minHeight: "100vh" }}>
      <CssBaseline />
      <Navbar />
      <Grid
        item
        xs
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Outlet />
        <ToastContainer />
      </Grid>
      {location.pathname !== ROUTE_PATHS.MASTERPASS_IFRAME && <Footer />}
    </Grid>
  );
}

function App() {
  const { fetchRemoteConfig } = useAuthState();
  const [loading, setLoading] = useState(false);
  // useLocationListener();

  useEffect(() => {
    const fetchConfig = async () => {
      setLoading(true);
      try {
        await fetchRemoteConfig();
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();

    /* const intervalId = setInterval(fetchConfig, 60000);*/ // 1 dakika aralıklarla kontrol

    /*  return () => clearInterval(intervalId);*/ // Bileşen unmount edildiğinde interval temizlenir
  }, [fetchRemoteConfig]);
  return (
    <HelmetProvider>
      {loading ? (
        <Stack
          sx={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Stack>
      ) : (
        <>
          <ScrollToTop />
          <AppContent />
        </>
      )}
    </HelmetProvider>
  );
}

export default App;
